import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ButtonGroup,
  Text,
  Flex,
  List,
  ListItem as ChakraListItem,
  ListIcon,
  Link,
} from '@chakra-ui/react';
import Button from 'common/components/button';
import { useState } from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import { FaCircleXmark } from 'react-icons/fa6';

const RefundPolicyModal = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size='xl'>
      <ModalOverlay />
      <ModalContent className='rounded-lg'>
        <ModalHeader className='text-xl font-medium border-b border-gray-200'>
          ReLease Refund Policy
        </ModalHeader>
        <ModalBody className='pt-4 pb-6'>
          <Flex className='flex-col gap-4 text-gray-500'>
            <Text className='text-base '>
              You may be eligible for a refund of payments made to ReLease in the following situations:
            </Text>
            <List className='flex flex-col gap-3'>
              <ChakraListItem className='flex items-start gap-1 ml-1'>
                <ListIcon as={FaCheckCircle} color='green.400' className='mt-1 rounded-full' />
                <Text className='text-base'>
                  <span className='font-medium text-black'>Lease Not Signed:</span>{' '}
                  If you purchase ReLease coverage before signing your lease and later choose not to sign, you are eligible for a full refund of any payments made to ReLease.
                </Text>
              </ChakraListItem>
              <ChakraListItem className='flex items-start gap-1 ml-1'>
                <ListIcon as={FaCheckCircle} color='green.400' className='mt-1 rounded-full' />
                <Text className='text-base'>
                  <span className='font-medium text-black'>
                    Pricing Adjustments:
                  </span>{' '}
                  After reviewing your lease agreement your pricing may be slightly adjusted if one or more of your lease term, unit layout, or monthly rent price is found to be different than the information provided. In this case, ReLease will contact you by email or phone and you will have the option to continue coverage at an adjusted rate or cancel your plan. If you choose to cancel your plan as a result of a pricing adjustment due to providing incorrect lease details, you will be refunded 95% of all payments made.
                </Text>
              </ChakraListItem>
            </List>
            <Text className='text-base'>
              Once your plan is activated on your lease start date, no refunds will be issued. For any questions, please contact our support team.
            </Text>
          </Flex>
        </ModalBody>
        <ModalFooter className='border-t border-gray-200'>
          <ButtonGroup>
            <Button title='I Understand' onClick={onClose} wFull={false} />
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

const RefundPolicyLink = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <Link
        onClick={() => setIsOpen(true)}
        className='hover:underline cursor-pointer'
      >
        {children || 'View Refund Policy'}
      </Link>
      <RefundPolicyModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

export { RefundPolicyModal, RefundPolicyLink };